export const sequence_wizard_en = {
  sequence_wizard_dialog_title: "Launch New Sequence",
  sequence_wizard_use_template: "Use template",
  sequence_wizard_back_to_preview: "Back to preview",
  launch: "Launch",

  sequence_wizard_choose_template: "Choose a template",
  sequence_wizard_preview: "Preview",
  sequence_wizard_configure: "Configure",

  sequence_wizard_choose_template_title: "Start by choosing a template",
  sequence_wizard_choose_template_desc:
    "Browse templates on the left to find one that matches your outreach style. Templates help you launch faster with proven message flows.",

  define_schedule: "Define Schedule",
  sequence_wizard_credentials_for: "Credential for {0}",
  apply_template: "Apply template",
};

export const sequence_wizard_ja = {
  sequence_wizard_dialog_title: "新しいシーケンスを開始",
  sequence_wizard_use_template: "テンプレートを使用",
  sequence_wizard_back_to_preview: "プレビューに戻る",
  launch: "開始",

  sequence_wizard_choose_template: "テンプレートを選択",
  sequence_wizard_preview: "プレビュー",
  sequence_wizard_configure: "設定",

  sequence_wizard_choose_template_title: "テンプレートを選択して開始",
  sequence_wizard_choose_template_desc:
    "左側のテンプレートを閲覧して、アウトリーチスタイルに合ったものを見つけてください。テンプレートを使用すると、実績のあるメッセージフローで迅速に開始できます。",

  define_schedule: "スケジュールを定義",
  sequence_wizard_credentials_for: "{0} の資格情報",
  apply_template: "テンプレートを適用",
};

export const sequence_wizard_ko = {
  sequence_wizard_dialog_title: "새 시퀀스 시작",
  sequence_wizard_use_template: "템플릿 사용",
  sequence_wizard_back_to_preview: "미리보기로 돌아가기",
  launch: "시작",

  sequence_wizard_choose_template: "템플릿 선택",
  sequence_wizard_preview: "미리보기",
  sequence_wizard_configure: "구성",

  sequence_wizard_choose_template_title: "템플릿 선택으로 시작",
  sequence_wizard_choose_template_desc:
    "왼쪽의 템플릿을 탐색하여 아웃리치 스타일에 맞는 템플릿을 찾으세요. 템플릿은 검증된 메시지 흐름으로 빠르게 시작할 수 있도록 도와줍니다.",

  define_schedule: "일정 정의",
  sequence_wizard_credentials_for: "{0}에 대한 자격 증명",
  apply_template: "템플릿 적용",
};

export const sequence_wizard_zh_cn = {
  sequence_wizard_dialog_title: "启动新序列",
  sequence_wizard_use_template: "使用模板",
  sequence_wizard_back_to_preview: "返回预览",
  launch: "启动",

  sequence_wizard_choose_template: "选择模板",
  sequence_wizard_preview: "预览",
  sequence_wizard_configure: "配置",

  sequence_wizard_choose_template_title: "从选择模板开始",
  sequence_wizard_choose_template_desc:
    "浏览左侧的模板，找到符合您外展风格的模板。模板帮助您快速启动，使用经过验证的信息流。",

  define_schedule: "定义计划",
  sequence_wizard_credentials_for: "凭据用于 {0}",
  apply_template: "应用模板",
};

export const sequence_wizard_zh_tw = {
  sequence_wizard_dialog_title: "啟動新序列",
  sequence_wizard_use_template: "使用模板",
  sequence_wizard_back_to_preview: "返回預覽",
  launch: "啟動",

  sequence_wizard_choose_template: "選擇模板",
  sequence_wizard_preview: "預覽",
  sequence_wizard_configure: "配置",

  sequence_wizard_choose_template_title: "從選擇模板開始",
  sequence_wizard_choose_template_desc:
    "瀏覽左側的模板，找到符合您外展風格的模板。模板幫助您快速啟動，使用經過驗證的信息流。",

  define_schedule: "定義計劃",
  sequence_wizard_credentials_for: "憑據用於 {0}",
  apply_template: "套用模板",
};

export const sequence_wizard_hi = {
  sequence_wizard_dialog_title: "नया अनुक्रम लॉन्च करें",
  sequence_wizard_use_template: "टेम्पलेट का उपयोग करें",
  sequence_wizard_back_to_preview: "पूर्वावलोकन पर वापस जाएं",
  launch: "लॉन्च करें",

  sequence_wizard_choose_template: "टेम्पलेट चुनें",
  sequence_wizard_preview: "पूर्वावलोकन",
  sequence_wizard_configure: "कॉन्फ़िगर करें",

  sequence_wizard_choose_template_title: "टेम्पलेट चुनकर शुरू करें",
  sequence_wizard_choose_template_desc:
    "बाईं ओर के टेम्पलेट ब्राउज़ करें और अपनी आउटरीच शैली से मेल खाने वाला टेम्पलेट चुनें। टेम्पलेट आपको सिद्ध संदेश प्रवाह के साथ तेज़ी से लॉन्च करने में मदद करते हैं।",

  define_schedule: "शेड्यूल परिभाषित करें",
  sequence_wizard_credentials_for: "{0} के लिए क्रेडेंशियल",
  apply_template: "टेम्पलेट अप्लाई करें",
};
